import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Observable";
import { HttpClient } from "@angular/common/http";

import { ResponseModel } from '../models/response.model';
import { GeneralService } from './general.service';
import { PersistenceService } from 'angular-persistence';
import { environment } from '../../environments/environment';
import { HttpParams } from '@angular/common/http';
import { MessageService } from 'primeng/components/common/messageservice';
import { GetImagebyPathModel } from '../models';

@Injectable()
export class UploadService extends GeneralService {
  constructor(protected messageService: MessageService, protected httpClient: HttpClient, protected persistenceService: PersistenceService) {
    super(messageService, httpClient, persistenceService, environment.apiPostUrl, "upload");
  }

  public getImageByPath(imagePath: any): Observable<ResponseModel> {
    let params = new HttpParams();
    params = params.append("imagePath", imagePath);
    return super.getCustomApi("getImageByPath", params);
  }

  async getImageByPathAsync(imagePath: any): Promise<any> {
    const res = await this.getImageByPath(imagePath).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async getImageByShipmentId(shipmentId: any, imageType: any, incidentsId: any = null) {
    let params = new HttpParams();
    params = params.append("shipmentId", shipmentId);
    params = params.append("imageType", imageType);
    params = params.append("incidentsId", incidentsId);
    let res =  await super.getCustomApi("GetImageByShipmentId", params).toPromise();
    // if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async uploadIamgeSubmitToTreasurer(model: any): Promise<any> {
    const res = await this.postCustomApi("UploadIamgeSubmitToTreasurer", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async uploadImageComplainHandle(model: any): Promise<any> {
    const res = await this.postCustomApi("UploadImageComplainHandle", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }

  async uploadDocCompensation(model: any): Promise<any> {
    const res = await this.postCustomApi("UploadDocCompensation", model).toPromise();
    if (!this.isValidResponse(res)) return;
    return res;
  }
  
  async getImageListReceiptMoney(model: any): Promise<any> {
    const res = await this.postCustomApi('GetImageListReceiptMoney', model).toPromise();
    if (!this.isValidResponse(res)) { return; }
    return res.data;
  }

  async uploadDeliveryCompleteNew(imageFile: any, fileName: any, shipmentId: number, imageType: number): Promise<ResponseModel> {
    const formData = new FormData();
    formData.append('Image', imageFile, fileName); 
    formData.append('ShipmentId', shipmentId.toString());
    formData.append('ImageType', imageType.toString());
    const res = await this.postCustomApi('UploadDeliveryCompleteNew', formData).toPromise();
    return res;
  }

  async deleteImageByShipmentId(model: GetImagebyPathModel) {
    const res = await this.postCustomApi('DeleteImageByShipmentId', model).toPromise();
    if (!this.isValidResponse(res)) {
      return null;
    }
    return res;
  }
}
